const allowedProcedureSides = new Set(["Left", "Right", "Both", "Middle"]);

export function normalizeProcedureSide(side: string | null | undefined): string {
    if (side == null) return "";
    const t = String(side).trim();
    if (!t) return "";
    const up = t.toUpperCase();
    if (up === "LEFT") return "Left";
    if (up === "RIGHT") return "Right";
    if (up === "BOTH") return "Both";
    if (up === "MIDDLE") return "Middle";
    return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
}

export function isProcedureSideUnset(side: string | null | undefined): boolean {
    if (side == null) return true;
    const s = String(side).trim();
    if (s === "" || s === "N/A") return true;
    return !allowedProcedureSides.has(normalizeProcedureSide(s));
}
